import React from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import { Phone, ArrowLeft, CheckCircle, Wrench, Flame, Droplets, HardHat, Activity, GitCommit, Layers, Thermometer } from 'lucide-react';

const serviceData = {
  'plumbing-repairs': {
    title: 'Plumbing Repairs & Installations',
    subtitle: 'Professional Plumbing Services in Yarmouth, NS',
    icon: Wrench,
    image: 'https://customer-assets.emergentagent.com/job_plumbing-heating-ns/artifacts/sgdjekh6_file_0000000021b871fdbb75717dd70f8b75%20%281%29.png',
    description: 'From leaky faucets to complete bathroom renovations, our licensed plumbers provide fast, reliable plumbing repairs and installations throughout Yarmouth County.',
    benefits: [
      'Fast response for emergency repairs',
      'Licensed journeyman plumbers',
      'Quality parts and workmanship',
      'Upfront pricing with no hidden fees',
    ],
    services: [
      'Leak detection and repair',
      'Faucet and fixture installation',
      'Toilet repairs and replacements',
      'Pipe repairs and repiping',
      'Drain cleaning and unclogging',
      'Water heater installation',
      'Bathroom and kitchen plumbing',
    ],
    metaTitle: 'Plumbing Repairs & Installations – Yarmouth NS',
    metaDescription: 'Licensed Yarmouth NS plumber providing plumbing repairs and installations. Fast, professional, and reliable service.',
  },
  'water-filtration': {
    title: 'Water Filtration Services',
    subtitle: 'Clean Water Solutions in Yarmouth, NS',
    icon: Droplets,
    image: 'https://customer-assets.emergentagent.com/job_plumbing-heating-ns/artifacts/6kwztpbl_file_00000000cc5471fda3a539ab5c1f652c.png',
    description: 'Ensure your family has access to clean, safe drinking water with our professional water filtration installation and maintenance services.',
    benefits: [
      'Improved water taste and quality',
      'Removal of contaminants',
      'Professional installation',
      'Ongoing maintenance available after installation.',
      'Various system options',
    ],
    services: [
      'Water quality testing',
      'Whole-house filtration systems',
      'Under-sink filters',
      'Water softener installation',
      'Reverse osmosis systems',
      'UV water purification',
      'Filter replacement service',
      'System maintenance',
    ],
    metaTitle: 'Water Filtration Services – Yarmouth NS',
    metaDescription: 'Licensed Yarmouth NS plumber providing water filtration services. Installation and maintenance included.',
  },
  'new-construction': {
    title: 'New Construction Plumbing',
    subtitle: 'Complete Plumbing for New Builds in Yarmouth, NS',
    icon: HardHat,
    image: 'https://customer-assets.emergentagent.com/job_plumbing-heating-ns/artifacts/tmjl6pvt_FB_IMG_1771192485955.jpg',
    description: 'Building a new home? Our licensed plumbers provide complete plumbing installations that meet all codes and standards for new construction projects.',
    benefits: [
      'Code-compliant installations',
      'Coordination with builders',
      'Quality materials',
      'Inspection ready',
      'Warranty included',
    ],
    services: [
      'Complete plumbing rough-in',
      'Fixture installation',
      'Water heater installation',
      'Sewer and drain installation',
      'Code compliance inspections',
      'Blueprint consultation',
      'Multi-unit installations',
    ],
    metaTitle: 'New Construction Plumbing – Yarmouth NS',
    metaDescription: 'Licensed Yarmouth NS plumber providing new construction plumbing. Full installations for new homes.',
  },
  'pump-installation': {
    title: 'Pump Installation & Servicing',
    subtitle: 'Professional Pump Services in Yarmouth, NS',
    icon: Activity,
    image: 'https://customer-assets.emergentagent.com/job_plumbing-heating-ns/artifacts/s9lq11vn_FB_IMG_1771192466965.jpg',
    description: 'From well pumps to sump pumps, we provide expert installation and servicing to keep your water systems running smoothly.',
    benefits: [
      'Expert pump diagnostics',
      'Quality pump brands',
      'Emergency service available',
      'Preventive maintenance',
      'Pressure system expertise',
    ],
    services: [
      'Well pump installation',
      'Sump pump installation',
      'Pressure tank replacement',
      'Pump repair and service',
      'Jet pump installation',
      'Submersible pump service',
      'Pressure switch adjustment',
      'Emergency pump repairs',
    ],
    metaTitle: 'Pump Installation & Servicing – Yarmouth NS',
    metaDescription: 'Licensed Yarmouth NS plumber providing pump installation and servicing. Well pumps, sump pumps, pressure systems.',
  },
  'blocked-sewers': {
    title: 'Blocked Sewers',
    subtitle: 'Professional Sewer Snaking in Yarmouth, NS',
    icon: GitCommit,
    image: 'https://customer-assets.emergentagent.com/job_plumbing-heating-ns/artifacts/sgdjekh6_file_0000000021b871fdbb75717dd70f8b75%20%281%29.png',
    description: 'Keep your drains flowing freely with our professional sewer snaking services. We clear even the toughest blockages up to 150ft.',
    benefits: [
      'Root removal expertise',
      'Preventive maintenance',
      'Same-day service available',
    ],
    services: [
      'Sewer snaking for unblocking up to 150ft',
      'Root removal',
      'Camera inspections',
      'Drain maintenance',
      'Grease trap cleaning',
      'Floor drain cleaning',
      'Emergency drain service',
    ],
    metaTitle: 'Blocked Sewers – Yarmouth NS',
    metaDescription: 'Licensed Yarmouth NS plumber providing sewer snaking services. Clear clogs, maintain sewer lines.',
  },
  'in-floor-heating': {
    title: 'In-Floor Heating Systems',
    subtitle: 'Radiant Floor Heating in Yarmouth, NS',
    icon: Layers,
    image: 'https://customer-assets.emergentagent.com/job_plumbing-heating-ns/artifacts/tmjl6pvt_FB_IMG_1771192485955.jpg',
    description: 'Experience ultimate comfort with in-floor heating systems. Perfect for Nova Scotia winters.',
    benefits: [
      'Even heat distribution',
      'Silent operation',
      'Increased comfort',
      'Works with various flooring',
    ],
    services: [
      'Hydronic floor heating',
      'System design and planning',
      'New construction installation',
      'Retrofit installations',
      'Thermostat integration',
      'System maintenance',
      'Repairs and troubleshooting',
    ],
    metaTitle: 'In-Floor Heating Systems – Yarmouth NS',
    metaDescription: 'Licensed Yarmouth NS plumber providing in-floor heating systems. Heating solutions.',
  },
  'electric-boiler': {
    title: 'Electric Boiler Installation & Servicing',
    subtitle: 'Expert Electric Boiler Services in Yarmouth, NS',
    icon: Thermometer,
    image: 'https://customer-assets.emergentagent.com/job_plumbing-heating-ns/artifacts/s9lq11vn_FB_IMG_1771192466965.jpg',
    description: 'Trust our licensed technicians for professional electric boiler installation, repair, and maintenance to keep your home warm and safe.',
    benefits: [
      'Licensed Plumber',
      'All major brands',
      '24/7 emergency service',
    ],
    services: [
      'Electric Boiler installation',
      'Radiator service',
      'Zone valve repair',
      'Emergency electric boiler service',
    ],
    metaTitle: 'Electric Boiler Installation & Servicing – Yarmouth NS',
    metaDescription: 'Licensed Yarmouth NS plumber providing electric boiler installation and servicing. Reliable home heating solutions.',
  },
};

export const ServiceDetail = () => {
  const { slug } = useParams();
  const service = serviceData[slug];

  if (!service) {
    return <Navigate to="/services" replace />;
  }

  const Icon = service.icon;

  return (
    <div data-testid="service-detail-page">
      {/* Hero Section */}
      <section className="relative py-32 bg-[#005B96]" data-testid="service-detail-hero">
        <div className="absolute inset-0">
          <img
            src={service.image}
            alt={service.title}
            className="w-full h-full object-cover opacity-20"
          />
        </div>
        <div className="relative container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
          <Link
            to="/services"
            className="inline-flex items-center gap-2 text-white/80 hover:text-white mb-6 transition-colors"
            data-testid="back-to-services"
          >
            <ArrowLeft size={20} />
            <span>Back to Services</span>
          </Link>
          <div className="flex items-center gap-4 mb-6">
            <div className="w-16 h-16 bg-white/10 backdrop-blur-sm rounded-2xl flex items-center justify-center">
              <Icon size={32} className="text-white" />
            </div>
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight mb-4">
            {service.title}
          </h1>
          <p className="text-xl text-white/90 max-w-2xl">
            {service.subtitle}
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20 md:py-28 bg-white" data-testid="service-detail-content">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
          <div className="grid lg:grid-cols-3 gap-12">
            {/* Main Content */}
            <div className="lg:col-span-2">
              <p className="text-xl text-gray-700 leading-relaxed mb-10">
                {service.description}
              </p>

              {/* Services List */}
              <h2 className="text-2xl font-bold text-gray-900 mb-6">What We Offer</h2>
              <div className="grid sm:grid-cols-2 gap-4 mb-10">
                {service.services.map((item, index) => (
                  <div key={index} className="flex items-center gap-3 p-4 bg-slate-50 rounded-xl">
                    <CheckCircle size={20} className="text-[#005B96] flex-shrink-0" />
                    <span className="text-gray-700">{item}</span>
                  </div>
                ))}
              </div>

              {/* Benefits */}
              <h2 className="text-2xl font-bold text-gray-900 mb-6">Why Choose Us</h2>
              <div className="space-y-4">
                {service.benefits.map((benefit, index) => (
                  <div key={index} className="flex items-start gap-4">
                    <div className="w-8 h-8 bg-[#E6F2FA] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                      <CheckCircle size={16} className="text-[#005B96]" />
                    </div>
                    <p className="text-gray-700 text-lg">{benefit}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Sidebar */}
            <div className="lg:col-span-1">
              <div className="sticky top-28">
                {/* CTA Card */}
                <div className="bg-[#005B96] text-white p-8 rounded-2xl shadow-xl mb-6">
                  <h3 className="text-xl font-bold mb-4">Ready to Get Started?</h3>
                  <p className="text-white/80 mb-6">
                    Contact us today for a free consultation and estimate.
                  </p>
                  <a
                    href="tel:902-746-0554"
                    className="flex items-center justify-center gap-2 bg-white text-[#005B96] w-full py-4 rounded-full font-bold hover:bg-[#FFD700] hover:text-black transition-all"
                    data-testid="service-detail-cta"
                  >
                    <Phone size={20} />
                    <span>902-746-0554</span>
                  </a>
                </div>

                {/* Contact Card */}
                <div className="bg-slate-50 p-6 rounded-2xl">
                  <h4 className="font-bold text-gray-900 mb-4">Service Area</h4>
                  <p className="text-gray-600 mb-4">
                    We proudly serve Yarmouth, Digby and Shelburne Counties.
                  </p>
                  <Link
                    to="/contact"
                    className="text-[#005B96] font-semibold hover:underline"
                  >
                    Contact Us →
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-slate-50">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
          <div className="bg-[#E6F2FA] rounded-3xl p-8 md:p-12 flex flex-col md:flex-row items-center justify-between gap-6">
            <div>
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
                Need {service.title}?
              </h2>
              <p className="text-gray-600">
                Our licensed plumbers are ready to help. Call today!
              </p>
            </div>
            <a
              href="tel:902-746-0554"
              className="inline-flex items-center gap-2 bg-[#005B96] text-white px-8 py-4 rounded-full font-bold hover:bg-[#004a7a] transition-all shadow-lg whitespace-nowrap"
              data-testid="service-detail-bottom-cta"
            >
              <Phone size={20} />
              <span>Call 902-746-0554</span>
            </a>
          </div>
        </div>
      </section>

      {/* Sticky Mobile CTA */}
      <div className="sticky-cta md:hidden">
        <a
          href="tel:902-746-0554"
          className="flex items-center justify-center gap-2 bg-[#005B96] text-white w-full py-4 rounded-full font-bold"
        >
          <Phone size={20} />
          <span>Call Now – 902-746-0554</span>
        </a>
      </div>
    </div>
  );
};

export default ServiceDetail;
